import { Bloc, delay } from "@kernel/frontend-react-app";
import { StatsState, defaultStatsState } from "./StatsState";
import { MainBloc } from "modules/main";
import { GetStatsFileInteractor, GetStatsLiveInteractor } from "./interactors";
import { StatsDto, StatsLiveService, StatsReport } from "@domain";

export class StatsBloc extends Bloc<StatsState> {
  private mainBloc: MainBloc | null = null;
  private getStatsFileInteractor: GetStatsFileInteractor;
  private getStatsLiveInteractor: GetStatsLiveInteractor;
  constructor() {
    super(defaultStatsState);
    this.getStatsFileInteractor = GetStatsFileInteractor.create();
    this.getStatsLiveInteractor = GetStatsLiveInteractor.create();
  }

  public setMainBloc(mainBloc: MainBloc) {
    this.mainBloc = mainBloc;
  }

  public getMainBloc(): MainBloc {
    if (!this.mainBloc) {
      throw new Error("MainBloc not set");
    }
    return this.mainBloc;
  }

  public async load(name: string): Promise<void> {
    this.getMainBloc().startLoading("Caricamento file statistiche...");
    try {
      await delay(500);
      const file = await this.getStatsFileInteractor.execute({ name });
      this.changeState({
        ...this.state,
        stats: file.stats
      });
    } catch (err) {
      this.getMainBloc().handleError(err);
    } finally {
      this.getMainBloc().stopLoading();
    }
  }

  public loadLive() {
    const statsLiveService = new StatsLiveService();
    const dto = statsLiveService.getStats();
    statsLiveService.subscribe((dto) => {
      this.changeLiveStats(dto);
    });
    if (dto === null) return;
    this.changeLiveStats(dto);
  }

  private changeLiveStats(dto: StatsDto | null) {
    const stats = this.getStatsLiveInteractor.execute({ dto });
    this.changeState({
      ...this.state,
      stats
    });
  }

  public start(onTick: (user: string) => (report: StatsReport) => void) {
    if (this.state.stats === null) {
      throw new Error("Stats not loaded");
    }
    const users = this.state.stats.getUsers();
    for (const user of users) {
      this.state.stats.startTicks(user, onTick(user));
    }
  }

  public stop() {
    if (this.state.stats === null) {
      throw new Error("Stats not loaded");
    }
    const users = this.state.stats.getUsers();
    for (const user of users) {
      this.state.stats.stopTicks(user);
    }
  }

  public static create(): StatsBloc {
    return new StatsBloc();
  }
}
